import { useLanguage } from '@/contexts/LanguageContext';
import { Clock, DollarSign, Car, Plane, UserCheck, Shield } from 'lucide-react';
import { motion } from 'framer-motion';

const FeaturesSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Clock, title: t.features.service247, desc: t.features.service247Desc },
    { icon: DollarSign, title: t.features.affordable, desc: t.features.affordableDesc },
    { icon: Car, title: t.features.comfort, desc: t.features.comfortDesc },
    { icon: Plane, title: t.features.airport, desc: t.features.airportDesc },
    { icon: UserCheck, title: t.features.professional, desc: t.features.professionalDesc },
    { icon: Shield, title: t.features.safe, desc: t.features.safeDesc },
  ];

  return (
    <section id="services" className="py-20 md:py-28 bg-muted">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">{t.features.title}</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">{t.features.subtitle}</p>
          <div className="w-16 h-1 bg-gradient-gold mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-card rounded-2xl p-8 shadow-card hover:shadow-gold/20 hover:-translate-y-1 transition-all group"
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-gold flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <f.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">{f.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
